import { render, staticRenderFns } from "./RecentMineView.vue?vue&type=template&id=32b63aaf&scoped=true"
import script from "./RecentMineView.vue?vue&type=script&lang=js"
export * from "./RecentMineView.vue?vue&type=script&lang=js"
import style0 from "./RecentMineView.vue?vue&type=style&index=0&id=32b63aaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b63aaf",
  null
  
)

export default component.exports